export default {
  SUCCESS_SUBMIT_CONTACT_US_FORM:
    'Thank you, our team will reply to your question within 1x24 hours.',
}
